import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import { Column, Row } from "simple-flexbox";
import { StyleSheet, css } from "aphrodite";
import { withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";

import UserReject from "../../assets/User Cross.png"

import {deleteJobSpot, jobSpotList} from "../../actions/jobspot/jobspot_action";
import {getJobSpot, getJobSpotError, getJobSpotPending} from "../../reducers/jobspot/jobspot";
import {toastSuccess} from "../../components/toast/Toast";

class Modal_Approval extends Component {
    constructor(props) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit() {
        const {
            deleteJobSpot,
            onHide,
            handleRefresh,
            jobSpotName,
        } = this.props;

        const param = {
            id: this.props.idJobSpot,
        }

        const callback = () => {
            onHide();
            setTimeout(() => {
                handleRefresh({page: 1, limit: 50});
            }, 1500)
            toastSuccess(`Data JobSpot ${jobSpotName} berhasil dihapus.`)
        };

        deleteJobSpot(param, callback, "rejected");
    }

    render() {
        const { show, onHide, jobSpotName } = this.props;

        return (
            <Modal
                show={show}
                onHide={onHide}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                size="md"
            >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <Row flex={"flex"} justifyContent="center">
                        <Column
                            vertical="center"
                            horizontal="center"
                            className={css(styles.bodyModal)}
                        >
                            <img src={UserReject} width="80px" alt="logo-usercheck"/>
                            <div style={{fontSize: 24, fontWeight: 700, margin: "30px 0 20px 0"}}>
                                Hapus Lowongan
                            </div>
                            <p style={{fontSize: 18, textAlign: "center", color: "#495057"}}>
                                Apakah Anda yakin akan menghapus data <b>{jobSpotName}</b>
                            </p>
                        </Column>
                    </Row>
                    <Row
                        flex="flex"
                        justifyContent="center"
                        vertical="center"
                        className={css(styles.footerModal)}
                    >
                        <Button
                            className={css(styles.rejectButton)}
                            variant="contained"
                            color="primary"
                            onClick={() => this.handleSubmit()}
                        >
                            OK
                        </Button>
                    </Row>
                </Modal.Body>
            </Modal>
        );
    }
}

const styles = StyleSheet.create({
    approveButton: {
        background: "#2CB96A 0% 0% no-repeat padding-box",
        boxShadow: "none",
        fontWeight: 500,
        width: "100%",
    },
    rejectButton: {
        background: "#EAEBED 0% 0% no-repeat padding-box",
        fontWeight: 500,
        width: "100%",
        color: "#fff",
        backgroundColor: "#F26664",
        boxShadow: "none",
    },
    footerModal: {
        width: "500px",
        backgroundColor: "#FBFBFD",
        padding: "20px 40px",
    },
    bodyModal: {
        padding: "0px 40px 20px",
        width: "100%",
    },
});

function mapStateToProps({ jobSpot }) {
    return {
        jobSpotList_pending: getJobSpotPending(jobSpot),
        jobSpotList_data: getJobSpot(jobSpot),
        jobSpotList_error: getJobSpotError(jobSpot),
    };
}

export default connect(mapStateToProps, {jobSpotList, deleteJobSpot})(withRouter(Modal_Approval));
